<!-- 患者查询 -->
<template>
  <layer pagename="patientSearch" pageClass="successCase">
    <div class="defc">
      <div class="successCase left">
        <div class="tabs">
          <Tabs v-model="tabsValue" @on-click="getData">
            <TabPane :label="label" name="1"></TabPane>
            <TabPane label="已回复" name="2"></TabPane>
          </Tabs>
        </div>
        <div class="search_input">
          <div class="from_b">
            <span class="label">提交分析时间</span>
            <DatePicker
              v-model="date"
              type="daterange"
              placement="bottom-end"
              placeholder="请选择"
            ></DatePicker>
            <span class="label">回复身份</span>
            <Select
              @on-change="search"
              clearable
              v-model="auditorType"
              placeholder="请选择回复身份"
            >
              <Option
                v-for="item in typeList"
                :value="item.value"
                :key="item.value"
                >{{ item.label }}</Option
              >
            </Select>
          </div>
          <Button type="primary" @click="search">查询</Button>
        </div>
        <div class="select_table">
          <Table
            ref="currentRowTable"
            highlight-row
            @on-row-click="rowClick"
            stripe
            border
            :columns="columns1"
            :data="list"
            :height="u_table_heigh"
          >
            <template slot-scope="{ row, index }" slot="action">
              <div class="btn_g">
                <Button @click.stop="lock(row, index)" type="default"
                  >查看</Button
                >
              </div>
            </template>
          </Table>
          <Page
            show-total
            show-sizer
            :page-size-opts="[5, 10, 20, 30, 40]"
            @on-change="pageChange"
            :total="totalCount"
            :page-size="pageSize"
            :current="pageIndex"
            @on-page-size-change="setPageSize"
          ></Page>
        </div>
      </div>
      <uDetail
        v-if="activeItem"
        :info="activeItem"
        @submitSuccess="submitSuccess"
        @close="closeDetail"
        :isReplied="tabsValue == '2'"
      />
    </div>
  </layer>
</template>
<script>
import dayjs from "dayjs";
import { mapGetters } from "vuex";
import uDetail from "./uDetail.vue";
let d = dayjs();
export default {
  components: { uDetail },
  props: ["id"],
  data() {
    return {
      tabsValue: "1",
      date: [], // [d.format("YYYY-MM-01"), d.format("YYYY-MM-DD")],
      auditorType: "", // 审核人员类型 1 医生 2 医术委员会
      activeItem: null,
      activeItemIndex: -1,
      showDetail: false,
      info: {},
      pageSize: 10, //一页10条
      pageIndex: 1,
      totalCount: 0,
      list: [],
      searchType: 2, //查询类型
      //弹窗打开
      medicalRecordOpen: false,

      // 医生本人、医术委员会
      typeList: [
        {
          value: 1,
          label: "医生本人",
        },
        {
          value: 2,
          label: "医术委员会",
        },
      ],
      // 表格高度
      u_table_heigh: 500,
      columns1: [],
      label: (h) => {
        return h("div", [
          h(
            "Badge",
            {
              props: {
                count: this.todoNumber.medicationExaminationNum,
              },
            },
            "待回复"
          ),
        ]);
      },
    };
  },
  computed: {
    ...mapGetters(["expert", "userInfo", "diseaseInfos2", "todoNumber"]),
  },
  methods: {
    closeDetail() {
      this.$refs.currentRowTable.clearCurrentRow();
      this.activeItem = null;
    },
    submitSuccess() {
      this.$refs.currentRowTable.clearCurrentRow();
      this.getData();
      this.$store.dispatch("todoNumber");
    },
    pageChange(index) {
      this.pageIndex = index;
      this.getData();
    },
    rowClick(data, index) {
      this.activeItem = data;
      this.showDetail = true;
    },
    lock(row, index) {
      this.activeItemIndex = index;
      this.activeItem = row;
      this.showDetail = true;
    },
    setPageSize(size) {
      this.pageSize = size;
      this.search();
    },
    getData() {
      this.setColumns();
      this.activeItem = null;
      let obj = {
        pageIndex: this.pageIndex, // 页码
        pageSize: this.pageSize, // 页大小
        checkFinishStartDate: null,
        checkFinishEndDate: null,
        auditorType: this.auditorType, // 审核人员类型 1 医生 2 医术委员会
      };
      if (this.date && this.date.length && this.date.every((i) => i)) {
        obj.checkFinishStartDate = dayjs(this.date[0]).format("YYYY-MM-DD");
        obj.checkFinishEndDate = dayjs(this.date[1]).format("YYYY-MM-DD");
      }

      this.$store.commit("openSpin");
      let url = this.tabsValue == "1" ? "waitReplyList" : "completeReplyList";
      this.api2(url, obj).then((res) => {
        this.$store.commit("closeSpin");
        this.totalCount = res.total;
        res.result.forEach((i) => {
          i.auditorTypeStr = this.common.valueToLabel(
            this.typeList,
            i.auditorType
          );
          i.auditDeadlineTimeStr =
            this.tabsValue == "1" && i.auditorType == 1 && i.auditDeadlineTime
              ? this.updateCountdown(i.auditDeadlineTime)
              : "/";
        });
        this.list = res.result;
      });
    },

    updateCountdown(endTime) {
      endTime = dayjs(endTime);
      const duration = dayjs.duration(endTime.diff(dayjs()));
      if (duration.asMilliseconds() <= 0) {
        return "";
      } else {
        return `${duration.days()}天 ${duration.hours()}小时 ${duration.minutes()}分钟`;
      }
    },

    refresh() {
      if (this.tabsValue == "1") {
        if (this.activeItem) {
          this.$Modal.confirm({
            title: "提示",
            content: "你有新的待回复, 是否自动加载?",
            width: "300px",
            onOk: () => {
              this.getData();
            },
          });
        } else {
          this.getData();
        }
      }
    },
    search() {
      this.pageIndex = 1;
      this.getData();
    },
    // 设置表格高度
    setTableHeight() {
      try {
        if ($(".successCase").length)
          this.u_table_heigh =
            $(".select_table")[0].clientHeight -
            $(".search_input")[0].clientHeight -
            35;
      } catch (error) {}
    },

    setColumns() {
      this.columns1 = [
        {
          title: "医馆",
          width: 180,
          key: "hospitalName",
        },
        {
          title: "姓名",
          width: 80,
          key: "patientName",
        },

        {
          title: "手机号",
          width: 130,
          key: "phoneNo",
        },
        {
          title: "年龄",
          width: 70,
          key: "patientAge",
        },
        {
          title: "性别",
          width: 70,
          key: "patientSex",
        },
        {
          title: "医生",
          width: 130,
          key: "doctorName",
        },
        {
          title: "提交分析时间",
          width: 180,
          key: "checkFinishTime",
        },
      ];
      if (this.tabsValue == "1") {
        this.columns1.push(
          {
            title: "回复身份",
            width: 130,
            key: "auditorTypeStr",
          },
          {
            title: "默认回复倒计时",
            key: "auditDeadlineTimeStr",
            minWidth: 160,
          }
        );
      } else {
        this.columns1.push({
          title: "回复身份",
          minWidth: 130,
          key: "auditorTypeStr",
        });
      }
    },
  },
  created() {
    this.getData();
    this.$store.dispatch("getDiagnosticList");
    this.$bus.on("TODONumber", this.refresh);
  },
  mounted: function () {
    this.setTableHeight();
    // 窗口大小调整
    $(window).resize(() => {
      this.setTableHeight();
    });
  },
  destroyed() {
    this.$bus.off("TODONumber", this.refresh);
  },
};
</script>
<style lang="scss" scoped>
.defc {
  display: flex;
  height: 100%;
  :deep {
    .ivu-badge-count {
      padding: 0;
      height: 16px;
      min-width: 16px;
      line-height: 16px;
      top: -5px;
      right: -5px;
    }
  }
}
.left {
  flex: 1;
  background: #fff;
  height: 100%;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  padding: 15px;
  .search_input {
    display: flex;
    justify-content: space-between;
    margin-bottom: 15px;
    height: 40px;
  }

  .select_table {
    flex: 1;
    display: flex;
    flex-direction: column;

    .ivu-table-wrapper {
      flex: 1;
      margin-bottom: 10px;
    }
  }

  .from_b .label {
    padding-right: 5px;
  }

  .from_b .ivu-select {
    width: 140px;
    margin-right: 15px;
  }
  .ivu-date-picker {
    display: inline-block;
    width: 200px;
    margin-right: 15px;
  }
  .defc {
    display: flex;
    justify-content: space-between;
    .successCase {
      flex: 1;
    }
  }
}
</style>

